module.exports = __webpack_public_path__ + "static/media/laugh-squint.ccded88c.svg";